import { evolve } from 'remeda';

import {
    type MaintenanceNote,
    type ReleaseNote,
    type UnityMaintenanceNote,
    type UnityReleaseNote,
} from '@@api/services/releasenotes/schemas';
import deserializeState from '@@plate/serialization/unity/utils/deserializeState';
import serializeState from '@@plate/serialization/unity/utils/serializeState';

export const deserializeReleasenote = (entity: UnityReleaseNote): ReleaseNote =>
    evolve(entity, {
        body: deserializeState,
    });

export const serializeReleasenote = (entity: ReleaseNote): UnityReleaseNote =>
    evolve(entity, {
        body: serializeState,
    });

export const deserializeMaintenancenote = (entity: UnityMaintenanceNote): MaintenanceNote =>
    evolve(entity, {
        note: deserializeState,
    });

export const serializeMaintenancenote = (entity: MaintenanceNote): UnityMaintenanceNote =>
    evolve(entity, {
        note: serializeState,
    });
